export default "__VITE_ASSET__Dkc2bf1B__"